import React, { useState } from "react"
import Clickable from "@components/Clickable"

import styles from "./tabs.module.scss"

const Tabs = ({ tabs, children }) => {
  const [active, setActive] = useState(tabs[0].key)

  return (
    <div className={styles.container}>
      <ul className={styles.tabs}>
        {tabs.map(tab => {
          return (
            <li
              key={tab.key}
              className={tab.key === active ? styles.active : undefined}
            >
              <Clickable
                onClick={() => {
                  setActive(tab.key)
                }}
              >
                {tab.title}
              </Clickable>
            </li>
          )
        })}
      </ul>
      <div className={styles.content}>{children(active)}</div>
    </div>
  )
}

export default Tabs
